import React, { useState } from 'react';
import '../../Assets/CSS/Contacts.scss';
import '../../Assets/CSS/Home.scss';
import contactHeroBackground from '../../Assets/Images/Aboutus/17973903.jpg';
import bgImage from '../../Assets/Images/Aboutus/bg-3.jpg';
import "../../Assets/CSS/Styles.scss";
import { API_BASE_URL } from '../../config';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import { Col, Row } from 'react-bootstrap';
import SuccessModal from "../../Componants/Models/SuccessModal";

const ContactPage = () => {

  const [formData, setFormData] = useState({
    fullName: '',
    emailAddress: '',
    mobileNumber: '',
    instituteType: '',
    budgetRange: '',
    designation: '',
    institutionName: '',
    projectDetails: '',
    updatesOptIn: false
  });

  const [errors, setErrors] = useState({
    fullName: '',
    emailAddress: '',
    mobileNumber: '',
    instituteType: '',
    designation: '',
    institutionName: '',
    projectDetails: ''
  });

  const [success, setSuccessMessage] = useState('');
  const [error, setErrorMessage] = useState('');

  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({
    title: "",
    message: "",
    isError: false
  });

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email) && (email.endsWith('.com') || email.endsWith('.org') || email.endsWith('.net') || email.endsWith('.edu') || email.endsWith('.in'));
  };

  const validateMobile = (mobile) => {
    const re = /^\d{10}$/;
    return re.test(mobile);
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {
      fullName: '',
      emailAddress: '',
      mobileNumber: '',
      instituteType: '',
      designation: '',
      institutionName: '',
      projectDetails: ''
    };

    // Validate required fields
    if (!formData.fullName.trim()) {
      newErrors.fullName = "Full name is required";
      valid = false;
    } else if (!/^[A-Za-z\s]{2,100}$/.test(formData.fullName.trim())) {
      newErrors.fullName = "Full name should only contain letters";
      valid = false;
    }


    if (!formData.emailAddress.trim()) {
      newErrors.emailAddress = 'Email is required';
      valid = false;
    } else if (!validateEmail(formData.emailAddress)) {
      newErrors.emailAddress = 'Please enter a valid email address (e.g. example@gmail.com)';
      valid = false;
    }

    if (!formData.mobileNumber.trim()) {
      newErrors.mobileNumber = 'Mobile number is required';
      valid = false;
    } else if (!validateMobile(formData.mobileNumber)) {
      newErrors.mobileNumber = 'Please enter a valid 10-digit mobile number';
      valid = false;
    }

    if (!formData.instituteType) {
      newErrors.instituteType = 'Institute type is required';
      valid = false;
    }

    if (!formData.designation.trim()) {
      newErrors.designation = 'Designation is required';
      valid = false;
    }

    if (!formData.institutionName.trim()) {
      newErrors.institutionName = 'Institution name is required';
      valid = false;
    }

    if (!formData.projectDetails.trim()) {
      newErrors.projectDetails = 'Project details are required';
      valid = false;
    } else if (wordCount > MAX_WORDS) {
      newErrors.projectDetails = `Project details cannot exceed ${MAX_WORDS} words`;
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "projectDetails") {
      const words = value.trim().split(/\s+/).filter(w => w.length > 0);

      if (words.length > MAX_WORDS) return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));

    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setModalData({
          title: "Thank You for Reaching Out!",
          message: "Your message has been submitted successfully. Our team will contact you within 24 hours.",
          isError: false
        });

        setShowModal(true);

        setFormData({
          fullName: "",
          emailAddress: "",
          mobileNumber: "",
          instituteType: "",
          budgetRange: "",
          designation: "",
          institutionName: "",
          projectDetails: "",
          updatesOptIn: false
        });
      } else {
        throw new Error("Failed to submit");
      }
    } catch (error) {
      setModalData({
        title: "Submission Failed ❌",
        message: "Something went wrong. Please try again later.",
        isError: true
      });

      setShowModal(true);
    }
  };
  const MAX_WORDS = 500;

  const wordCount = formData.projectDetails
    .trim()
    .split(/\s+/)
    .filter(word => word.length > 0).length;

  const percentage = Math.min((wordCount / MAX_WORDS) * 100, 100);

  const isWarning = wordCount >= 450 && wordCount <= MAX_WORDS;
  const isOverLimit = wordCount > MAX_WORDS;

  return (
    <div className="contact-page-container mt60">
      {/* Hero Section */}
      <div className="relative h-[500px] md:h-[488px] flex items-center justify-center p-2 overflow-hidden">
        <div
          className="absolute inset-0 bg-center bg-cover animate-slowZoom"
          style={{ backgroundImage: `url(${contactHeroBackground})` }}
        ></div>
        <div className="absolute inset-0 bg-black bg-opacity-60 backdrop-blur-[3px] z-10"></div>

        <div className="relative z-10 text-white text-center max-w-4xl space-y-7">
          <div className="animate-fadeSlideIn delay-100">
            <div className="inline-flex items-center px-3 py-1 mb-4 text-sm font-medium text-black bg-[#ffdd9d] rounded-full">
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Ready to Transform Your Institution?
            </div>
          </div>
          <h1 className="font-heading font-bold-500 text-2xl md:text-4xl lg:text-5xl animate-fadeSlideIn delay-200">
            Let's Bring Your <span className="text-[#FBBF24]">Vision</span> to Life
          </h1>
          <p className="font-ui text-md leading-6 animate-fadeSlideIn delay-300">
            Reach out to us — we usually reply within 24 hours with a personalized
            <br />
            consultation tailored to your institution's unique needs.
          </p>
        </div>
      </div>

      {/* Contact Form */}
      <section id='contactForm'>

        <div className="text-center mt-4 md:mb-12">
          <h2 className="font-heading mb-3 text-[25px] font-bold text-gray-900">
            Ready to Transform Your Institution?
          </h2>
          <p className="text-sm md:text-base text-gray-600 font-ui max-w-2xl mx-auto">
            Share your vision with us and Let's Build Something Extraordinary Together!
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 max-w-7xl mx-auto overflow-hidden mt-4 mb-4">
          {/* Left Visual Section */}
          <div className="hidden lg:flex bg-white px-8 items-center justify-center">
            <div className="max-w-xl w-full p-2 md:p-6">
              <div className="lottie-container">
                <DotLottieReact
                  src="https://lottie.host/4a27ccfc-8228-4920-9aaa-afbbbd79f01b/gLliwmBVSj.lottie"
                  loop
                  autoplay
                  className="w-[auto] h-[420px]"
                />
              </div>
            </div>
          </div>

          {/* Right Form Section */}
          <div className="bg-white px-4 sm:px-6 lg:px-8 flex justify-center">
            <div className="w-full max-w-xl p-4 md:p-6 border border-[#F59E0B] rounded-2xl">

              <form className="space-y-1">
                <Row className="g-2 mb-2">
                  <Col md>
                    <div className="floating-group">
                      <input
                        type="text"
                        id="fullName"
                        name="fullName"
                        value={formData.fullName}
                        onChange={handleChange}
                        placeholder=" "
                      />
                      <label htmlFor="fullName">Full Name *</label>
                      {errors.fullName && <p className="form-error">{errors.fullName}</p>}
                    </div>
                  </Col>
                  <Col md>
                    <div className="floating-group">
                      <input
                        type="email"
                        id="emailAddress"
                        name="emailAddress"
                        placeholder=" "
                        value={formData.emailAddress}
                        onChange={handleChange}
                      />
                      <label htmlFor="emailAddress">Email Address *</label>
                      {errors.emailAddress && <p className="form-error">{errors.emailAddress}</p>}
                    </div>

                  </Col>
                </Row>

                <Row className="g-2 mb-2">
                  <Col md>
                    <div className="floating-group">
                      <input
                        type="tel"
                        id="mobileNumber"
                        placeholder=" "
                        inputMode="numeric"
                        pattern="[0-9]*"
                        name="mobileNumber"
                        value={formData.mobileNumber}
                        onChange={handleChange}
                      />
                      <label htmlFor="mobileNumber">Mobile Number *</label>
                      {errors.mobileNumber && <p className="form-error">{errors.mobileNumber}</p>}
                    </div>
                  </Col>
                  <Col md>
                    {/* Institute Type */}
                    <div className="floating-group">
                      <select
                        id="instituteType"
                        name="instituteType"
                        placeholder=""
                        value={formData.instituteType}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Institute Type</option>
                        <option value="Technical">Technical</option>
                        <option value="Medicalcollege">Medical</option>
                        <option value="Engineering">Engineering</option>
                        <option value="ArtsCommerceScience">Arts, Commerce, Science</option>
                        <option value="Corporate">Corporate</option>
                        <option value="Other">Other</option>
                      </select>

                      <label htmlFor="instituteType">Institute Type *</label>

                      {errors.instituteType && (
                        <p className="form-error">{errors.instituteType}</p>
                      )}
                    </div>
                  </Col>
                </Row>

                <Row className="g-2 mb-2">
                  <Col md>
                    <div className="floating-group">
                      <input
                        type="text"
                        id="designation"
                        name='designation'
                        placeholder=" "
                        value={formData.designation}
                        onChange={handleChange}
                      />
                      <label htmlFor="designation">Role / Designation *</label>
                      {errors.designation && <p className="form-error">{errors.designation}</p>}
                    </div>

                  </Col>
                  <Col md>
                    <div className="floating-group">
                      <select
                        id="budgetRange"
                        name="budgetRange"
                        value={formData.budgetRange}
                        onChange={handleChange}
                      >
                        <option value="">Select budget range</option>
                        <option value="less-than-1L">Less than 1,00,000</option>
                        <option value="1L-5L">1,00,000 - 5,00,000</option>
                        <option value="5L-10L">5,00,000 - 10,00,000</option>
                        <option value="more-than-10L">More than 10,00,000</option>
                      </select>

                      <label htmlFor="budgetRange">Budget Range *</label>

                      {errors.budgetRange && (
                        <p className="form-error">{errors.budgetRange}</p>
                      )}
                    </div>
                  </Col>
                </Row>


                <Row className="g-2 mb-2">
                  <Col>
                    <div className="floating-group">
                      <input
                        type="text"
                        id="institutionName"
                        name='institutionName'
                        placeholder=" "
                        value={formData.institutionName}
                        onChange={handleChange}
                      />
                      <label htmlFor="institutionName">Institution / Company Name *</label>
                      {errors.institutionName && <p className="form-error">{errors.institutionName}</p>}
                    </div>

                  </Col>
                </Row>

                <Row className="g-2 mb-3">
                  <Col>
                    <div className="floating-group premium-textarea">

                      <textarea
                        name="projectDetails"
                        id="projectDetails"
                        rows="5"
                        placeholder=" "
                        value={formData.projectDetails}
                        onChange={handleChange}
                        className={isOverLimit ? "limit-exceeded" : ""}
                      />

                      <label htmlFor="projectDetails">Project Details *</label>

                      {/* Premium Animated Counter */}
                      <div className="counter-wrapper">

                        <div className="counter-top">
                          <span className="helper-text">
                            Describe your project (max {MAX_WORDS} words)
                          </span>

                          <span
                            className={`word-count ${isOverLimit
                              ? "over"
                              : isWarning
                                ? "warning"
                                : ""
                              }`}
                          >
                            {wordCount} / {MAX_WORDS}
                          </span>
                        </div>

                        {/* Animated Progress Bar */}
                        <div className="progress-bar-container">
                          <div
                            className={`progress-bar ${isOverLimit
                              ? "over"
                              : isWarning
                                ? "warning"
                                : ""
                              }`}
                            style={{ width: `${percentage}%` }}
                          />
                        </div>
                      </div>

                      {errors.projectDetails && (
                        <p className="form-error">{errors.projectDetails}</p>
                      )}

                    </div>
                  </Col>
                </Row>

                <div className="flex items-start mb-2 mt-2">
                  <input
                    type="checkbox"
                    id="updatesOptIn"
                    name="updatesOptIn"
                    className="mt-1 custom-checkbox-advanced"
                    checked={formData.updatesOptIn}
                    onChange={(e) =>
                      setFormData({ ...formData, updatesOptIn: e.target.checked })
                    }
                  />
                  <label htmlFor="updatesOptIn" className="ml-2 text-sm mb-2">
                    I'd like to receive updates about new features, case studies, and educational technology insights.
                  </label>
                </div>

                <button type="button" className="contact-button font-ui "
                  onClick={handleSubmit}
                >
                  Send Message
                </button>

                <p className="contact-note">
                  We respect your privacy and will never share your information.
                </p>

              </form>
              {success && <p className="text-green-600 text-center mb-4">{success}</p>}
              {error && <p className="text-red-600 mb-4">{error}</p>}
            </div>
          </div>
        </div>
        <SuccessModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          title={modalData.title}
          message={modalData.message}
          isError={modalData.isError}
        />
      </section>

      {/* Contact Info Section */}
      <section className="relative py-16 bg-gray-50">
        {/* Background - Only shown on desktop */}
        <div className="hidden md:block absolute inset-0 bg-cover bg-center bg-no-repeat z-0"
          style={{
            backgroundImage: `url(${bgImage})`,
            maskImage: 'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
            WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)',
          }}>
          <div className="absolute inset-0 bg-white bg-opacity-80"></div>
        </div>

        <div className="relative z-10 container mx-auto px-4 sm:px-6 max-w-7xl">
          <div className="text-center mb-8 md:mb-12">
            <h2 className="font-heading mb-3  text-[25px] font-bold text-gray-900">
              Prefer a Different Way to Connect?
            </h2>
            <p className="text-sm md:text-base text-gray-600 font-ui max-w-2xl mx-auto">
              Choose the communication method that works best for you
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            {[
              {
                title: 'Call Us',
                desc: 'Speak directly with our experts',
                icon: (
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                ),
                link: (
                  <a
                    href="tel:+917588601162"
                    className="contact-link"
                  >
                    +91 758 860 1162
                  </a>
                ),
              },
              {
                title: 'Email Us',
                desc: 'Send us a detailed message',
                icon: (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8m-2 6V7a2 2 0 00-2-2H5a2 2 0 00-2 2v7a2 2 0 002 2h14a2 2 0 002-2v-3"
                  />
                ),
                link: (
                  <a
                    href="mailto:sales@globalsolutions.com"
                    className="contact-link"
                  >
                    sales@globalsolutions.in
                  </a>
                ),
              },
              {
                title: 'Visit Us',
                desc: (
                  <a
                    href="https://www.google.com/maps/search/?api=1&query=Office+No+13,+5th+Floor,+Glory+Business+Hub,+Pune+Nashik+Hwy,+near+Bhosale+Pride,+Borhade+Wadi,+Moshi,+Pimpri+Chinchwad,+Maharashtra+411070"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-link"                  >
                    Office No. 13, 5th Floor, Glory Business Hub, Pune - Nashik Hwy, near Bhosale Pride, Borhade Wadi, Moshi, Pimpri-Chinchwad, Maharashtra 411070
                  </a>

                ),
                icon: (
                  <>
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M17.657 16.657L13.414 20.9a2 2 0 01-2.828 0L6.343 16.657a8 8 0 1111.314 0z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </>
                ),
              }


            ].map(({ title, desc, icon, link }, i) => (
              <div
                key={i}
                className="relative bg-white border-2 border-amber-500 rounded-xl shadow-sm p-6 pt-10 text-center transition-all duration-300 hover:scale-105 hover:shadow-lg"
              >
                {/* Floating Icon */}
                <div className="absolute -top-8 left-1/2 transform -translate-x-1/2">
                  <div className="w-16 h-16 flex items-center justify-center rounded-full bg-amber-100 border-2 border-white shadow-md">
                    <svg
                      className="h-8 w-8 text-amber-500"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      {icon}
                    </svg>
                  </div>
                </div>

                {/* Card Content */}
                <div className="mt-10">
                  <h3 className="text-[20px] font-bold text-[#111827] mb-2">{title}</h3>
                  <p className="text-[15px] text-[#374151] font-ui mb-2">{desc}</p>
                  {link}
                </div>
              </div>
            ))}
          </div>

          {/* add google map  */}


          {/* Google Map Section */}
          <div className="mb-16">
            <h3 className="font-heading mb-3 text-[25px] font-bold text-gray-900 text-center">
              Find Us on the Map
            </h3>
            <div className="bg-white rounded-md shadow-md border-1 border-amber-400 overflow-hidden">
              <iframe
                title="Global Solutions Location"
                src="https://www.google.com/maps?q=Office+No+13,+5th+Floor,+Glory+Business+Hub,+Pune+Nashik+Hwy,+near+Bhosale+Pride,+Borhade+Wadi,+Moshi,+Pimpri+Chinchwad,+Maharashtra+411070&output=embed"
                width="100%"
                height="500"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="w-full"
              ></iframe>
            </div>
          </div>

          {/* Response Stats */}

          <div className="text-center mb-8 md:mb-12">
            <h2 className="font-heading mb-3  text-[25px] font-bold text-gray-900">
              Our Response Promise
            </h2>
            <p className="text-sm md:text-base text-gray-600 font-ui max-w-2xl mx-auto">
              We typically respond to all inquiries within 24 hours. For urgent matters, please call us directly.
            </p>
          </div>


          <div className="grid grid-cols-2 md:grid-cols-3 gap-8 contact-stat-title font-heading text-center">
            {[
              ['10+', 'Years Experience'],
              ['24hrs', 'Service Support'],
              ['99.9%', 'Uptime Guaranteed'],


            ].map(([stat, label], i) => (
              <div key={i} className="p-4 rounded-lg">
                <h3
                  className="contact-stat-title animate-bounceTopToBottom"
                  style={{ animationDelay: `${i * 0.5}s` }}
                >
                  {stat}
                </h3>
                <p className="contact-stat-sub">{label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div >
  );
};

export default ContactPage;
